module.exports = __webpack_public_path__ + "img/img10.8ee43572.png";